import { message, Radio, RadioChangeEvent } from 'antd';
import { useState } from 'react';
import Flag from 'react-flagpack';

import {
  Drawer,
  ErrorBoundary,
  GenericDrawerHeader,
} from '../../../../../components/index';
import {
  DockingWasteCollectionItemType,
  useUpdateDockingWasteCollectionMutation,
} from '../../../../../services/wasteCollectionApi';
import { createDateStringPtBr } from '../../../../../utils/utils';
import { isWasteCollectionSent } from '../environmentTable/columns';
import { Container, Header } from './styles';

type EnvironmentDrawerProps = {
  isVisible: boolean;
  onClose: () => void;
  selectedDocking: DockingWasteCollectionItemType | null;
  onWasteCollectionSaved: (dockingId: number) => void;
};

const wasteCollectionOptions = [
  { label: 'Sim', value: true },
  { label: 'Não', value: false },
];

type WasteCollectionFieldProps = {
  docking: DockingWasteCollectionItemType;
  onSaved: (dockingId: number) => void;
};

function WasteCollectionField({ docking, onSaved }: WasteCollectionFieldProps) {
  const [pendingValue, setPendingValue] = useState<boolean | undefined>(
    undefined
  );

  const [updateWasteCollection, { isLoading }] =
    useUpdateDockingWasteCollectionMutation();

  const isSent = isWasteCollectionSent(docking);

  const hasWasteCollection = isSent
    ? docking.sent_has_waste_collection
    : pendingValue ?? docking.has_waste_collection;

  async function onChangeWasteCollection(event: RadioChangeEvent) {
    setPendingValue(event.target.value);
    try {
      await updateWasteCollection({
        docking_id: docking.docking_id,
        has_waste_collection: event.target.value,
      }).unwrap();
      onSaved(docking.docking_id);
      message.success('Coleta de resíduo atualizada.');
    } catch (error) {
      setPendingValue(undefined);
    }
  }

  return (
    <>
      <Radio.Group
        optionType="button"
        buttonStyle="solid"
        options={wasteCollectionOptions}
        value={hasWasteCollection}
        onChange={onChangeWasteCollection}
        disabled={isSent || isLoading}
      />
      {isSent && docking.last_date_xml && (
        <span className="hint">
          Enviado no XML de movimentação em{' '}
          {createDateStringPtBr(docking.last_date_xml)}
        </span>
      )}
    </>
  );
}

export function EnvironmentDrawer(props: EnvironmentDrawerProps) {
  const { isVisible, onClose, selectedDocking, onWasteCollectionSaved } = props;

  function getTitle() {
    return (
      <Header>
        <span className="code">{selectedDocking?.docking_code}</span>
        <div className="vessel">
          <div style={{ width: '20px' }}>
            {selectedDocking?.vessel_flag && (
              <ErrorBoundary replace="">
                <Flag code={selectedDocking.vessel_flag} size="s" />
              </ErrorBoundary>
            )}
          </div>
          <span>{selectedDocking?.vessel_name}</span>
        </div>
      </Header>
    );
  }

  return (
    <Drawer visible={isVisible} closable={false} width={600} destroyOnClose>
      <GenericDrawerHeader title={getTitle()} showBackButton onBack={onClose} />
      <Container>
        <span className="label">Houve coleta de resíduo?</span>
        {selectedDocking && (
          <WasteCollectionField
            key={selectedDocking.docking_id}
            docking={selectedDocking}
            onSaved={onWasteCollectionSaved}
          />
        )}
      </Container>
    </Drawer>
  );
}
